module.exports = __webpack_public_path__ + "static/img/img.fbe84cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/img.jpg
// module id = MWSd
// module chunks = 1